import * as yup from 'yup'

export const dailyReportSchema = yup.object({
  _id: yup.string().required(),
  dayOfReport: yup.date().required(),
  createdAt: yup.date().required(),
  updatedAt: yup.date().required(),
})
